import api from './client';

// A one-time token for opening an EventSource, which can't send an Authorization header. Going
// through `api` gives it the early refresh and the 401 retry every other request gets: the plain
// fetch() the streams used before failed silently once the access token expired.
export async function fetchSseToken(signal) {
  const { data } = await api.post('/auth/sse-token', {}, { signal });
  return data.token;
}
